<template lang="pug">
	.page
			.wrapper.wrapper_max
				router-link.back(to='/video/') всі відео
					span
			.wrapper
				.video
					.video__title(v-text="page.name" data-aos="fade-up")
					.video__date(v-text="getDate(page.date)" data-aos="fade-up" data-aos-delay="200")
					.video__video(data-aos="fade-up" data-aos-delay="400")
						iframe(v-if="page.url_vimeo" :src="'https://player.vimeo.com/video/'+page.url_vimeo+'?autoplay=1&color=383838&title=0&byline=0&badge=0'" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen)
						iframe(v-if="page.youtube_id" :src="'https://www.youtube.com/embed/'+page.youtube_id+'?autoplay=1'" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
			.wrapper(v-if="getProductsByIds(page.products) && getProductsByIds(page.products).length")
				.cultures
					.cultures__title(data-aos="fade-up") Пов’язані продукти
					.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
						swiper.cultures__swiper(ref="swiper1" :options="{allowTouchMove: false,loop: (getProductsByIds(page.products).length <= 4 ? false : true),slidesPerView: 4,navigation: {nextEl: '.cultures__arrow_right',prevEl: '.cultures__arrow_left'}, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
							swiperSlide(
								v-for="(card, index) in getProductsByIds(page.products)"
								:key="index"
							)
								section-card(
									:card="card"
									:type="'product'"
									:link="'/products/' + (catalogs.length ? getCatalogById(card.catalogs[0]).slug : '') + '/' + card.slug + '/'"
								)
						template(v-if="getProductsByIds(page.products).length > 4")
							button.cultures__arrow.cultures__arrow_left
							button.cultures__arrow.cultures__arrow_right
					.cultures__bottom(data-aos="fade-up")
						router-link.cultures__more(to='/products/') Всі продукти
							span

				.section(v-if="videos.length-1")
					.section__title(data-aos="fade-up") Останні відео
					.section__swiper-container.section__swiper-container_2(data-aos="fade-up" data-aos-delay="200")
						.section__swiper-wrapper
							swiper.section__swiper( ref="swiper1" :options="{allowTouchMove: false,loop: false,slidesPerView: 3, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
								swiperSlide(
									v-for="(card, index) in videos"
									:key="index"
									v-if="card.slug != $route.params.slug"
								)
									section-card(
										:card="card"
										:type="'video'"
										:link="'/video/' + card.slug + '/'"
									)
						template(v-if="videos.length-1 > 3")
							button.section__arrow.section__arrow_left( @click="slidePrev")
							button.section__arrow.section__arrow_right( @click="slideNext")
					.section__bottom(data-aos="fade-up")
						router-link.section__more(to='/video/') Всі відео
							span

			block-footer
</template>

<script>

  let collectionSlug = 'videos';

	import ListSection from '@/components/listSection.vue';
	import sectionCard from '@/components/sectionCard.vue';

	import AOS from 'aos';

	import {mapState, mapGetters} from 'vuex';
	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper';

	export default {
		name: collectionSlug,
		metaInfo: function() {
			let th = this;

			return {
				title: 'Відео — ' + th.page.name
			}
		},
		data: function(){
			return {
				page: {}
			}
		},
		created() {
			if (!this[collectionSlug].length) this.$store.dispatch('GET_COLLECTION', collectionSlug);

			if (this[collectionSlug].length) {
				this.page = this.getVideoBySlug(this.$route.params.slug);
			}

			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
			if (!this.products.length) this.$store.dispatch('GET_COLLECTION', 'products');
		},
		components: {
			'list-section': ListSection,
			'section-card': sectionCard,
			swiper,
			swiperSlide,
		},
		methods: {
			getDate(date) {
				let d = new Date(date);
				var dd = d.getDate();
				var mm = d.getMonth() + 1;

				var yyyy = d.getFullYear();
				if (dd < 10) {
					dd = '0' + dd;
				}
				if (mm < 10) {
					mm = '0' + mm;
				}
				return dd + '.' + mm + '.' + yyyy;
			},
			slideNext() {
				this.$refs.swiper1.swiper.slideNext();
			},
			slidePrev() {
				this.$refs.swiper1.swiper.slidePrev();
			}
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		computed: {
			...mapState([
				collectionSlug,
				'products',
				'catalogs',
			]),
			...mapGetters([
				'getProductsByIds',
				'getCatalogById',
				'getVideoBySlug'
			])
		},
		watch: {
			videos() {
				if (this.videos.length) {
					this.page = this.getVideoBySlug(this.$route.params.slug);
				}
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import '@/helpers/sass/kit.scss';

	.cultures {
		margin-top: 50px;
		margin-bottom: 50px;

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
			margin-top: 16px;
		}

		&__swiper-container {
			position: relative;
		}

		&__arrow {
			position: absolute;
			top: 20px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 1;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -50px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -50px;
			}
		}

    >>> .card {
			margin-bottom: 57px;
			margin-top: 20px;
		}

		&__bottom {
			text-align: center;
			position: relative;
			z-index: 1;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: 23px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	.back {
		text-transform: uppercase;
		display: inline-block;
		height: 50px;
		background-color: #fff;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		font: 500 19px/50px 'Helvetica', Arial, sans-serif;
		color: #333333;
		padding: 2px 41px 0 91px;
		letter-spacing: 2px;
		position: relative;
		margin-bottom: 28px;

		span {
			display: block;
			position: absolute;
			width: 50px;
			height: 100%;
			top: 0;
			left: 0;
			background: url('../assets/img/back_red.svg') no-repeat center center;
			transition: transform .5s ease;
			transform: translate3d(0, 0, 1px);
		}

		&:after {
			content: "";
			display: block;
			position: absolute;
			width: calc(100% - 50px);
			height: 100%;
			top: 0;
			right: 0;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		}
	}

	.page {
		margin-top: 5px;
		margin-bottom: 100px;
	}

	.video {
		max-width: 847px;
		margin-bottom: 80px;

		&__date {
			margin-top: 11px;
			font: 21px/25px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}

		&__video {
			margin-top: 17px;
			padding: 58.2% 0 0 0;
			position: relative;
		}

		&__title {
			@include kit('sectionTitle');
		}
	}

	.section {
		margin: 94px 0;

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
		}

		&__swiper-container {
			position: relative;
			margin-top: 16px;
		}

		&__swiper-wrapper {
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		&__arrow {
			position: absolute;
			top: 20px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 1;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -49px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -49px;
			}
		}

    >>> .card {
			margin-bottom: 57px;
			margin-top: 20px;
		}

		&__bottom {
			text-align: center;
			position: relative;
			z-index: 1;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: 23px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	@media screen and (max-width: 1200px) {

		.cultures {
			&__arrow {
				display: none;
			}

			&__more {
				margin-top: 50px;
			}

			.section__swiper-container {
				width: calc(100% + 40px);
				margin-left: 0px;
			}

      >>> .swiper-slide {
				padding: 0 10px;
				width: 266px;
			}

      >>> .card {
				width: 246px;
				margin: 0;
			}
		}

		.back {
			background-color: #fff;
			color: #333;
			margin-left: -20px;
			position: relative;

			span {
				background: url('../assets/img/back_red.svg') no-repeat center center;
				position: absolute;
				top: 0;
				left: 0;
				width: 50px;
				height: 100%;
			}
		}

		.page {
			margin-top: 10px;
		}

		.section__arrow {
			display: none;
		}

    >>> .swiper-slide {
			padding-right: 10px;
		}

		.swiper-container {
			margin-left: 0;
			width: calc(100% + 10px);
			padding: 30px 0;
		}
	}
</style>
